import {PageManager} from 'genesis-packages/core';
import './CABK.scss';

export default class CABK extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

};
